export default __webpack_public_path__ + "static/media/Imperial.5928991d.jpg";